import { connect } from 'react-redux';
import React, { PropTypes } from 'react';
import { updateExistingCaseType } from '../actions/form';
import { getExistingCaseType, getErrors } from '../reducers/form';
import cx from 'classnames';
import { Button } from 'semantic-ui-react';

export const NEW_CASE = 'NEW';
export const EXISTING_CASE = 'EXISTING';

const mapStateToProps = state => ({
  existingCaseType: getExistingCaseType(state),
  errors: getErrors(state),
});
const mapDispatchToProps = dispatch => ({
  updateExistingCaseType: event =>
    dispatch(updateExistingCaseType(event.target.value)),
});

const ExistingCaseType = ({
  existingCaseType,
  updateExistingCaseType,
  errors,
}) => {
  const fieldClass = cx('field required', {
    error: errors.includes('existingCaseType'),
  });

  return (
    <div className="ui segment">
      <div className="two fields">
        <div className={fieldClass}>
          <label>Quel est le type de votre chantier ?</label>
          <Button.Group>
            <Button
              type="button"
              positive={existingCaseType === NEW_CASE}
              value={NEW_CASE}
              onClick={updateExistingCaseType}
            >
              Nouvelle installation
            </Button>
            <Button.Or text="ou" />
            <Button
              type="button"
              positive={existingCaseType === EXISTING_CASE}
              value={EXISTING_CASE}
              onClick={updateExistingCaseType}
            >
              Reprise d'un chantier déjà installé
            </Button>
          </Button.Group>
        </div>
        <div className="field" />
      </div>
    </div>
  );
};

ExistingCaseType.propTypes = {
  existingCaseType: PropTypes.string.isRequired,
  updateExistingCaseType: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(ExistingCaseType);



// WEBPACK FOOTER //
// ./src/modules/saas/aast/cases-creation/step1/components/ExistingCaseType.js